<template>
  <div class="login-container bg">
    <div class="login-box">
      <div class="p-panel">
        <div class="p-panel-content">
          <form @submit.prevent="onLogin">
            <div class="p-grid">
              <div class="p-col-12 p-fluid">
                <div class="p-field">
                  <label for="username" v-tooltip="`รหัสเข้าเครื่องคอมพิวเตอร์`"
                    >ระบุรหัสผู้ใช้งาน</label
                  >
                  <InputText
                    id="username"
                    v-model="login.username"
                    class="login-input"
                    :class="{ 'p-invalid': v$.username.$error }"
                  ></InputText>
                  <small
                    class="p-error"
                    v-for="(error, index) in v$.username.$errors"
                    :key="`u${index}`"
                    >{{ error.$message }}</small
                  >
                </div>
              </div>
              <div class="p-col-12 p-fluid">
                <div class="p-field">
                  <label
                    for="password"
                    v-tooltip="`ใช้รหัสเดียวกับรหัสผ่านเข้าคอมพิวเตอร์`"
                    >ระบุรหัสผ่าน</label
                  >
                  <Password
                    id="password"
                    v-model="login.password"
                    class="login-input"
                    toggleMask
                    :class="{ 'p-invalid': v$.password.$error }"
                  ></Password>
                  <small class="p-error" v-if="v$.password.$error">{{
                    v$.password.required.$message
                  }}</small>
                </div>
              </div>
              <div class="p-col-12 p-fluid">
                <Button
                  type="submit"
                  label="ยืนยัน"
                  icon="pi pi-check"
                  class="p-button-success p-mt-5 login-input"
                ></Button>
              </div>
              <div class="p-col-12 p-field">
                <Button
                  class="p-button-text p-button-sm"
                  label="ตรวจสอบบัญชี / ลืมรหัสผ่าน"
                  @click="onPopupWac"
                ></Button>
              </div>
            </div>
          </form>

          <div class="p-grid">
            <div class="p-col-12">
              <small>Haadthip Company Limited 2021</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { usePlugin } from "@/plugins";
import { LoginResponse, LoginRequest } from "@/types";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers, minLength } from "@vuelidate/validators";
export default defineComponent({
  name: "Login",
  setup() {
    const {
      error,
      axios,
      useState,
      router,
      setIdentity,
      route,
      setLoading,
      getUserProfile,
    } = usePlugin();

    const login = ref({
      username: "",
      password: "",
    });

    const rules = {
      username: {
        required: helpers.withMessage("กรุณาระบุ Username", required),
        minLength: helpers.withMessage(
          "กรุณาระบุ ความยาว 4 ตัวอักษรอย่างน้อย",
          minLength(4)
        ),
      },
      password: {
        required: helpers.withMessage("กรุณาระบุ Password", required),
      },
    };
    const v$ = useVuelidate(rules, login, { $autoDirty: true });
    const state = useState();

    const onLogin = async (e: any) => {
      v$.value.$reset();
      v$.value.$touch();
      if (v$.value.$invalid) return;

      setLoading(true);
      try {
        const response = await axios.post<LoginResponse>("api/v1/login", {
          username: login.value.username,
          password: login.value.password,
          system: "hrdsmart",
        } as LoginRequest);

        if (response.data.message != "") {
          error(response.data.message);
        } else {
          // store.commit("login", {
          //   token: response.data.token,
          //   username: response.data.employeeId,
          // });
          state.value.authentication.token = response.data.token;
          state.value.authentication.username = response.data.employeeId;
          setIdentity();
          await getUserProfile();

          const name = route.query["name"] as string;
          const params = JSON.parse((route.query["params"] as string) ?? "{}");
          if (name) {
            router.replace({ name: name, params: params });
          } else {
            await router.replace({ name: "menu" });
          }
        }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onPopupWac = () => {
      window.open("https://minutemaid.haadthip.com/ad_check/", "_blank");
    };

    return {
      onLogin,
      onPopupWac,

      login,

      v$,
    };
  },
});
</script>

<style lang="scss">
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login-box {
  box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;
  max-width: 400px;
  min-width: 400px;
}

.login-input,
.login-input span,
.login-input input {
  font-size: 2rem;
}

// body,
// html {
//   height: 100%;
// }

.bg {
  background: url(../../public/img/login_bg.jpg) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100vh !important;
}
</style>
